import { useEffect, useState } from "react";
import type { UserDto } from "@gatiq/shared";
import { Card, CardBody, Page, PageBody, PageHeader, Skeleton, useToast } from "@/ui";
import { api, ApiClientError } from "@/lib/api";
import { QrPosterPanel } from "@/components/QrPosterPanel";

interface MeCounter extends UserDto {
  registrationUrl: string | null;
}

/** The printable poster, full page — `/:orgSlug/counter/qr`. */
export function CounterQrPage() {
  const toast = useToast();
  const [me, setMe] = useState<MeCounter | null>(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get<MeCounter>("/org/me/counter")
      .then((res) => {
        if (!cancelled) setMe(res);
      })
      .catch((err: unknown) => {
        toast.error(err instanceof ApiClientError ? err.message : "Could not load your registration QR.");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Page>
      <PageHeader title="Registration QR" />
      <PageBody>
        <Card className="mx-auto max-w-md">
          <CardBody>
            {me?.registrationUrl ? (
              <QrPosterPanel
                counterName={me.name}
                counterPhone={me.phone}
                qrPngUrl="/api/org/me/counter/qr.png"
                registrationUrl={me.registrationUrl}
              />
            ) : (
              <div className="flex flex-col items-center gap-4">
                <Skeleton className="size-56" />
                <Skeleton className="h-9 w-full" />
              </div>
            )}
          </CardBody>
        </Card>
      </PageBody>
    </Page>
  );
}
